<div class="container-fluid bgColor">
  <div class="employeePage">
    <div class="">
      <!-- Card One -->
      <div class="absence-container">
        <div class="row">
          <div class="absence-left-col col-md-6">
            <div class="absence-left">
              <h2 class="px-3 absence">Absence Request</h2>
              <div class="d-flex">
                <span>32 Request</span>
              </div>
            </div>
          </div>
          <div class="absence-right-col col-md-6">
            <div class="absence-right">
              <button class="report-button">
                Pending <span class="report-button-span">12</span>
              </button>
              <button class="report-button secondary">
                Approved <span class="report-button-span">12</span>
              </button>
              <button class="report-button secondary">
                Rejected <span class="report-button-span">12</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Card Two -->
      <div class="row">
        <div class="col-md-12 row leaveHead">
          <div class="col-md-2 leaveType">
            <div class="annualLeave card">
              <h6>Annual Leave</h6>
              <span class="annualDay">45</span>
              <p class="percentage">
                <span class="text-success">+31% </span>from last month
              </p>
            </div>
          </div>
          <div class="col-md-2 leaveType">
            <div class="annualLeave card">
              <h6>Bereavement leave</h6>
              <span class="annualDay">5</span>
              <p class="percentage">
                <span class="text-success">+22% </span>less from last month
              </p>
            </div>
          </div>
          <div class="col-md-2 leaveType">
            <div class="annualLeave card">
              <h6>Casual Leave</h6>
              <span class="annualDay">25</span>
              <p class="percentage">
                <span class="text-danger">-2% lesser </span>last month
              </p>
            </div>
          </div>
          <div class="col-md-2 leaveType">
            <div class="annualLeave card">
              <h6>Compensatory off</h6>
              <span class="annualDay">6</span>
              <p class="percentage">
                <span class="text-success">+31% </span>from last month
              </p>
            </div>
          </div>
          <div class="col-md-2 leaveType">
            <div class="annualLeave card">
              <h6>Work from home</h6>
              <span class="annualDay">45</span>
              <p class="percentage">
                <span class="text-success">+31% </span>from last month
              </p>
            </div>
          </div>
          <div class="col-md-2 leaveType">
            <div class="annualLeave card">
              <h6>Sick Leave</h6>
              <span class="annualDay">45</span>
              <p class="percentage">
                <span class="text-success">+31% </span>from last month
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Card Three -->
      <div class="row py-3">
        <div class="gap-2 align-items-center">
          <!-- Search Input -->
          <div class="input-group search-group m-1">
            <span class="input-group-text bg-white search-group-icon">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              class="form-control search-group-input"
              placeholder="Search Employee"
              aria-label="Search"
            />
          </div>

          <!-- Attendance Filters Button -->
          <div class="btn-group absence-filter-parent">
            <button
              type="button"
              class="btn dropdown-toggle absence-filter-btn"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa-solid fa-filter"></i> Attendance Filters
            </button>
            <ul class="dropdown-menu absence-filter-list">
              <li><a class="dropdown-item" href="#">Present</a></li>
              <li><a class="dropdown-item" href="#">Absent</a></li>
              <li><a class="dropdown-item" href="#">Late Clock-In</a></li>
            </ul>
          </div>

          <!-- Create -->
          <div class="btn-group create-btn-parent m-1">
            <button type="button" class="btn">
              <i class="fa-solid fa-plus px-2"></i>Create
            </button>
          </div>
        </div>
      </div>

      <!-- Card Four -->
      <!-- <div class="container"> -->
      <div class="">
        <p-table
          styleClass="p-datatable-gridlines"
          [value]="products"
          [tableStyle]="{ 'min-width': '60rem' }"
          [paginator]="true"
          [rows]="5"
          [rowsPerPageOptions]="[5, 10, 20]"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="code" style="width: 25%">
                <img
                  src="../../../../../../assets/img/Attendence Icon/user.svg"
                  alt=""
                />
                Employee name /ID
                <i class="fa-solid fa-sort table-sort-icon"></i>
              </th>
              <th pSortableColumn="name" style="width: 20%">
                <img
                  src="../../../../../../assets/img/Attendence Icon/Group 1171281106.svg"
                  alt=""
                />
                Leave Type
                <i class="fa-solid fa-sort table-sort-icon" field="name"></i>
              </th>
              <th pSortableColumn="category" style="width: 25%">
                <i class="fa-regular fa-clock"></i> Date
                <i class="fa-solid fa-sort table-sort-icon"></i>
              </th>
              <th pSortableColumn="quantity" style="width: 15%">
                <img
                  src="../../../../../../assets/img/Attendence Icon/Vector-2.svg"
                  alt=""
                />
                Duration <i class="fa-solid fa-sort table-sort-icon"></i>
              </th>
              <th style="width: 13%">
                <img
                  src="../../../../../../assets/img/Attendence Icon/Vector-1.svg"
                  alt=""
                />
                Reason
              </th>
              <th style="width: 17%" class="text-center">
                <img
                  src="../../../../../../assets/img/Attendence Icon/Vector.svg"
                  alt=""
                />
                Approved
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product>
            <tr>
              <td>
                <div class="d-flex employee-image">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/User_icon_2.svg/1200px-User_icon_2.svg.png"
                    class="absence-table-user-image"
                    alt=""
                  />
                  <div class="align-content-center">
                    <div>{{ product.code }}</div>
                    <span class="user-mobile-number">358223289</span>
                  </div>
                </div>
              </td>
              <td>{{ product.name }}</td>
              <td>
                {{ product.category }}
              </td>
              <td>{{ product.quantity }}</td>
              <td><i class="fa-regular fa-file-lines"></i></td>
              <td class="d-flex">
                <button class="btn"><i class="fa-solid fa-xmark"></i></button
                ><button class="btn btn-sm d-flex approveBtn">
                  <i class="fa-solid fa-check"></i>Approve
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- </div> -->
    </div>
  </div>
</div>
